import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';

import { ListingCard } from '../../components';
import TopbarSearchForm from '../TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';

import { searchUserListings } from './ProfilePage.duck';
import { storeSearchParams } from './storeSearchParams';
import css from './CompanyProfilePage.module.css';

/* Store-scoped search + listings grid for the company profile.
 *
 * The search box is the same TopbarSearchForm used in the global
 * header, but its submit searches THIS seller's listings in place —
 * it re-queries by author_id + the typed filters and refreshes the
 * grid on the profile, instead of navigating to the SearchPage. */
const StoreListingsSection = props => {
  const { listings, profileUserId, displayName } = props;
  const config = useConfiguration();
  const dispatch = useDispatch();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  /* P25009-432 — the shop page gets the same filter pattern as search by
   * handing filtering over to the seller-scoped SearchPage: /annonser with
   * authorId keeps the seller pinned through every filter change, renders
   * the seller's store card in the header, and on mobile opens the same
   * full-screen filter sheet as everywhere else. One filter, one code
   * path, and the filtered URL is shareable/bevakbar (BR-7, BR-9). */
  const openStoreFilter = () => {
    if (!profileUserId) return;
    history.push(
      createResourceLocatorString('SearchPage', routeConfiguration, {}, {
        authorId: profileUserId,
        ...(displayName ? { showByUser: displayName } : {}),
      })
    );
  };

  const handleSubmit = values => {
    if (!profileUserId) return;

    // Shared with the Katalog section, so both boxes search the same way.
    const searchParams = storeSearchParams(values, config);

    dispatch(searchUserListings(profileUserId, searchParams, config));
  };

  return (
    <section className={css.listingsSection}>
      <div className={css.secHead}>
        <h2>Annonser</h2>
        <span className={css.secHeadCount}>({listings.length})</span>
      </div>

      <div className={css.storeSearch}>
        <TopbarSearchForm
          className={css.storeSearchForm}
          appConfig={config}
          onSubmit={handleSubmit}
        />
      </div>

      {profileUserId ? (
        <button type="button" className={css.storeFilterButton} onClick={openStoreFilter}>
          Filtrera annonser
        </button>
      ) : null}

      {listings.length > 0 ? (
        <ul className={css.listingsGrid}>
          {listings.map(l => (
            <li className={css.listingCell} key={l.id.uuid}>
              <ListingCard listing={l} showAuthorInfo={false} showFavoriteIcons={true} />
            </li>
          ))}
        </ul>
      ) : (
        <p className={css.noListings}>Inga annonser matchar din sökning.</p>
      )}
    </section>
  );
};

export default StoreListingsSection;
